import { useOrganizationStore, useSubscriptionsStore } from 'store/modules';

export default {
    get isAgency() {
        const organizationStore = useOrganizationStore();

        return organizationStore.isAgency;
    },

    get isAgencyWithSubscription() {
        const subscriptionsStore = useSubscriptionsStore();
        const subscription = subscriptionsStore.subscription;

        return (
            this.isAgency && subscription && ['active', 'trialing'].includes(subscription.status)
        );
    },

    get isAgencyWithoutSubscription() {
        const subscriptionsStore = useSubscriptionsStore();
        const subscription = subscriptionsStore.subscription;

        return (
            this.isAgency &&
            (!subscription || !['active', 'trialing', 'past_due'].includes(subscription.status))
        );
    },

    get isV2auth() {
        const organizationStore = useOrganizationStore();

        return organizationStore.isV2auth;
    },
};
